require('./brokerExAntItem.scss')
const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { FormattedText, formatText } = require('core/i18n').i18n;

// @components
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @images
const privateIcon = require("assets/images/info-icon.svg");
const ccIcon = require('assets/images/icon-tutorial.svg');

// helpers
const { formatCurrency, formatWithoutRound, formatPercentage } = require('utilities/currencyHelper');
const { recordLinkV2 } = require("utilities/tagging");

// @ constants
const {
    EXANT_COST_ASSOCIATED_TO_SERVICE,
    EXANT_COST_SUCCESS_COMMISSION
}= require('constants/index');
class BrokerExAntItem extends React.Component {

    buildKey(key) {
        const { context } = this.props;
        return `${context}-${key}`
    }

    buildEventTag(sectionKey, labelKey) {
        const { context } = this.props;
        return `${context}-${sectionKey}_${labelKey}`
    }

    eventTag() {
        const { data, eventCategory, sectionTitle, context } = this.props;
        if (!!eventCategory) {
            const eventTag = `${context}-${sectionTitle}_${data.get('descriptionKey')}_eventTag`;
            recordLinkV2({
                categoriaEvento: eventCategory,
                accionEvento: 'tooltip',
                etiquetaEvento: formatText(eventTag),
            })
        }
    }

    buildComplexTooltip(key){
        return(
            <React.Fragment>
                <FormattedText value={key}/>
            </React.Fragment>
        );
    }

    render() {
        const { data, complexTooltip, sectionTitle } = this.props;
        const label = data.get('descriptionKey');
        const tooltipKey = data.get('tooltipKey');
        const type = data.get('type');
        const isHiden = data.get('hidden');
        if (type === null || !!isHiden) {
            return null;
        }
        const currency = formatCurrency(data.get('currency') ? data.get('currency') : 'EUR');
        const amount = formatWithoutRound(data.get('amount'), 2);
        const immPercentage = formatWithoutRound(data.get('percentage'), 2);

        const formattedAmount =
            data.get("amount") !== null
                ? amount.includes("-") &&
                  (label == EXANT_COST_ASSOCIATED_TO_SERVICE ||
                      tooltipKey === EXANT_COST_SUCCESS_COMMISSION)
                    ? "-"
                    : `${amount} ${currency}`
                : formatText("exAntCost-notAvailableData");

        const percentage =
            data.get("percentage") !== null
                ? immPercentage.includes("-") &&
                  (label === EXANT_COST_ASSOCIATED_TO_SERVICE ||
                      tooltipKey === EXANT_COST_SUCCESS_COMMISSION)
                    ? "-"
                    : formatPercentage(data.get("percentage"))
                : "-";

        const tooltipContentKey = `${sectionTitle}_${data.get('descriptionKey')}_${tooltipKey}`;
        const tooltipTitleKey = `${sectionTitle}_${data.get('descriptionKey')}_${tooltipKey}_title`;

        let itemClass, labelClass, dataClass, labelText;
        switch (type) {
            case 'SUBSECTION':
                itemClass = 'broker-ex-ant-cost__item-spaced';
                labelClass = 'broker-ex-ant-cost__item-label';
                dataClass = 'broker-ex-ant-cost__item-data-strong';
                labelText = <FormattedText value={this.buildKey(label)} />
                break;
            case 'FOOTNOTE':
                itemClass = 'broker-ex-ant-cost__item-indented';
                labelClass = 'broker-ex-ant-cost__item-label-light';
                dataClass = 'broker-ex-ant-cost__item-data';
                labelText = (
                    <FormattedText
                        value={this.buildKey(label)}
                        injectedStrings={[formattedAmount, percentage]}
                    />
                )
                break;
            case 'TOTAL':
                itemClass = 'broker-ex-ant-cost__item-total';
                labelClass = 'broker-ex-ant-cost__item-label-total';
                dataClass = 'broker-ex-ant-cost__item-data-total';
                labelText = <FormattedText value={this.buildKey(label)} />
                break;
            case 'COST':
            default:
                itemClass = 'broker-ex-ant-cost__item-spaced';
                labelClass = 'broker-ex-ant-cost__item-label-light';
                dataClass = 'broker-ex-ant-cost__item-data';
                labelText = <FormattedText value={this.buildKey(label)} />
                break;
        }

        const tooltipIcon = __CONTACT_CENTER__ ? ccIcon : privateIcon;
        const tooltipTarget = (<img onMouseEnter={() => this.eventTag()} className="broker-ex-ant-cost__item-tooltip" src={tooltipIcon}></img>);

        const Tooltip = data.get("tooltipKey") ? (
            <OKTooltip
                title={
                    !!tooltipTitleKey && !complexTooltip
                        ? formatText(this.buildKey(tooltipTitleKey))
                        : null
                }
                content={
                    complexTooltip
                        ? this.buildComplexTooltip(this.buildKey(tooltipContentKey))
                        : formatText(this.buildKey(tooltipContentKey))
                }
                placement="top"
                type={complexTooltip ? "custom" : "explicative"}
                target={tooltipTarget}
                offset={[0, -15]}
            />
        ) : null;

        return (
            <div className={itemClass}>
                <span className={labelClass}>
                    { labelText }
                    { Tooltip }
                </span>
                {type !== 'FOOTNOTE' &&
                    <span className={dataClass}>
                        { formattedAmount } | { percentage }
                    </span>
                }
            </div>
        );
    }
}

BrokerExAntItem.defaultProps = {
    complexTooltip: false,
}

BrokerExAntItem.propTypes = {
    data: PropTypes.object.isRequired,
    context: PropTypes.string.isRequired,
    eventCategory: PropTypes.string,
    sectionTitle: PropTypes.string,
    complexTooltip: PropTypes.bool,
};

module.exports = BrokerExAntItem;
